import { serviceRequest } from 'utils/http';
import { InvestigatorService } from 'common/api';

export function getGetInvestigatorStudiesAPI() {
  return serviceRequest(() =>
    InvestigatorService.investigatorControllerGetInvestigatorStudies()
  );
}
